import React from 'react'
import inOrasImg from '../images/partners/InOras.jpg'
import teleMImg from '../images/partners/logo_telem.png'
import radioHitImg from '../images/partners/radiohit.png'
import impactImg from '../images/partners/logo_impact.png'
import iasitvlifeImg from '../images/partners/iasitvlife.jpg'
import apolloniaTvImg from '../images/partners/logo-apollonia-tv.png'
import pressOnSecurityImg from '../images/partners/PressOnSecurity_LogoSmall.jpg'
import ziarulDeIasiImg from '../images/partners/ziarul-de-iasi_logo.jpg'
import acorduriDinSufletLogoImg from '../images/partners/AcorduriDinSuflet_LogoSmall.png'
import exposeLogoImg from '../images/partners/logo_expose.png'


const MediaEntry = (props) => {
	return (
		<div className="row">
			<div className="col-md-12 col-sm-12 wow fadeInUp">
				<div className="team-wrapper">
					<div className="row">
                        <div className="col-md-3">
							<a href={props.link} target="_blank"><img src={props.image} className="img-responsive"/></a>
                            <br />
						</div>
						<div className="col-md-9">
                            <br />  
							<h4><a href={props.link} target="_blank">{props.title}</a></h4>
							<p>
								{props.text}
							</p>
							<p>&nbsp;</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

let articles = [
	{
		title: "Expose.ro - Wednesday, 17 April" ,
		link: "http://www.expose.ro/devexperience-a-patra-mare-adunare-a-evanghelistilor-in-it-inainte-de-prima-venire-a-papei-la-iasi/",
		text: "DevExperience, a patra mare adunare a evangheliștilor în IT, înainte de prima venire a Papei la Iași",
		image: exposeLogoImg
	},
	{
		title: "Ziarul de Iași - Monday, 15 April" ,
		link: "https://www.ziaruldeiasi.ro/stiri/it-isti-din-toata-lumea-se-aduna-in-aprilie-la-iasi-pentru-a-4-a-mare-adunare-a-evanghelistilor-din-it--216506.html",
		text: "IT-iști din toată lumea se adună în aprilie la Iași, pentru a 4-a mare adunare a evangheliștilor din IT",
		image: ziarulDeIasiImg
	},
	{
		title: "Acorduri din suflet - Thursday, 4 April" ,
		link: "https://www.biancaionel.com/blog/devexperience-2019/" ,
		text: "DEVEXPERIENCE 2019 – THE 4TH GATHERING OF IT EVANGELISTS BEFORE THE 1ST COMING OF THE POPE",
		image: acorduriDinSufletLogoImg
	},
	{
		title: "Apollonia TV - Tuesday, 2 April" ,
		link: "https://www.youtube.com/watch?v=bUDxd9o-4yY&fbclid=IwAR3ir16KU9IZGncfXqZLseAACwHzdCMBr-cKeaxZ5-iegsLmMeuX1tulWv4" ,
		text: "DevExperience 2019",
		image: apolloniaTvImg
	},
	{
		title: "Impact FM - Tuesday, 2 April" ,
		link: "https://impactfm.ro/conferinta-it-aprilie-2019-devexperience-a-iv-a-editie/" ,
		text: "CONFERINȚĂ IT (APRILIE 2019): DEVEXPERIENCE A IV- A EDIȚIE",
		image: impactImg
	},
	{
		title: "Press On Security - Monday, 1 April" ,
		link: "https://pressonsecurity.co.uk/2019/04/01/devexperience-helps-the-it-community-in-iasi-grow/" ,
		text: "DevExperience helps the IT community in Iasi grow",
		image: pressOnSecurityImg
	},
	{
		title: "Radio Hit FM - Monday, 1 April" ,
		link: "https://www.radiohit.ro/stiri/iasul-se-pregateste-de-un-nou-eveniment-remarcabil-devexperience/" ,
		text: "AUDIO IAȘUL SE PREGĂTEȘTE DE UN NOU EVENIMENT REMARCABIL: DEVEXPERIENCE",
		image: radioHitImg
	},
	{
		title: "Tele M - Wednesday, 27 March" ,
		link: "http://telem.ro/it-isti-din-toata-lumea-se-aduna-in-aprilie-la-iasi-pentru-a-4-a-mare-adunare-a-evanghelistilor-din-it/",
		text: "IT-iști din toată lumea se adună în aprilie la Iași, pentru a 4-a mare adunare a evangheliștilor din IT",
		image: teleMImg
	},
	{
		title: "In oraș - Wednesday, 27 March" ,
		link: "http://iasi.inoras.ro/eveniment/it-isti-din-toata-lumea-se-aduna-in-aprilie-la-iasi-pentru-a-4-a-mare-adunare-a-evanghelistilor-din-it-55860/",
		text: "IT-iști din toată lumea se adună în aprilie la Iași, pentru a 4-a mare adunare a evangheliștilor din IT",
		image: inOrasImg
	},
	{
		title: "Iași TV Life - Tuesday, 26 March" ,
		link: "http://iasitvlife.ro/index.php/emisiuni/investim-in-iasi/item/66662-investim-in-iasi-devexperience-4-conferinta-internationala-absolut-normala-de-it?fbclid=IwAR3O5lnepNfE23epqnqoiYF8vztwXYBtHRLTOPp0QQ58Ij_nBM7lqe4BYYI" ,
		text: "INVESTIM ÎN IAȘI - DevExperience 4 - Conferința Internațională Absolut Normală de IT",
		image: iasitvlifeImg
	}
	
]

const mediaAppearancesIndex = () => {
	return (
	<section id="community" className="parallax-section">
		<div className="container">
		<br /><br /><br /><br />
        <div className="row">
            <div className="col-md-offset-2 col-md-8 col-sm-offset-2 col-sm-8">
				<div className="header-title">
					<h4 className="heading">Media appearances</h4>
					<hr />
					<p>This is how DevExperience 2019 appeared in the media.</p>
				</div>
			</div>
        </div>
		{ articles.map(article => <MediaEntry {...article} />)}
		</div>
	</section>
	)
}
export default mediaAppearancesIndex


// WEBPACK FOOTER //
// ./src/pages/media-appearances.js